<style>
  .layout.row {
    margin-bottom: 20px!important;
  }
</style>

<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align:right">
          <h3 style="float:left">Шаблоны писем</h3>
          <v-btn
                  color="pink"
                  dark
                  small
                  fab
                  @click="editOpen()">
                    <v-icon>add</v-icon>
          </v-btn>
          <v-btn
                  color="blue"
                  dark
                  small
                  fab
                  @click="refresh()">
                    <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>        
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Поиск"
              v-model="search"
              hide-details
              class="hidden-sm-and-down"
              ></v-text-field>     
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>         
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="emailTemplateData"
                :rows-per-page-items="[10,25,50,100]"
                class="elevation-1"
                item-key="id"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
                v-model="complex.selected"
                >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.title }}</td>
                  <!-- <td>{{ props.item.sendPulseEmailTemplateId }}</td> -->
                  <td>{{ props.item.isActive == true ? "Да": "Нет" }}</td>
                  <td>{{ props.item.emailSubject }}</td>
                  <td>
                    <v-btn depressed outline icon fab dark color="primary" small @click="editOpen(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="pink" small @click="removeItemConfirm(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn> 
                  </td>
                </template>
              </v-data-table>

              <!-- Редактирование -->
              <div slot="widget-content">

                <v-dialog v-model="popupEdit.isOpen" persistent max-width="800px" max-height="600px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout row v-if="readonlyFields">
                          <v-flex xs4>
                            <v-subheader>ID шаблона</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                            <v-text-field
                                    label="ID шаблона"
                                    v-model="modalData.id"
                                    readonly
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Название шаблона</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field
                                    label="Название шаблона"
                                    v-model="modalData.title"
                                    :rules="rules.required"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>ID шаблона в SendPulse</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field
                                    label="ID шаблона в SendPulse"
                                    v-model="modalData.sendPulseEmailTemplateId"
                                    :rules="rules.required"
                                    readonly
                                    @click="checkOpen()"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Тема письма</v-subheader>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field
                                    label="Тема письма"
                                    v-model="modalData.emailSubject"
                                    :rules="rules.required"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-subheader>Активность</v-subheader>
                          </v-flex>
                          <v-flex xs8 >
                              <v-switch v-model="modalData.isActive"></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                    
                    <v-card-actions>
                      <v-btn flat @click="editCancel()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="editSave()">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>

              <!-- Список шаблонов -->
              <div slot="widget-content">
                <v-dialog v-model="popupCheck.isOpen" persistent width="calc(100vw - 100px)" height="600px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">
                        Выбор шаблона письма SendPulse
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="complexBySendPulse.headers"
                        :items="sendPulseEmailTemplateData"
                        :rows-per-page-items="[10,25,50,100]"
                        class="elevation-1"
                        item-key="id"
                        no-results-text="Нет результатов"
                        rows-per-page-text="На странице"
                        v-model="complexBySendPulse.selected"
                        >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.real_id }}</td> 
                          <td>{{ props.item.name }}</td>
                          <td>{{ props.item.created }}</td>
                          <td><a :href="props.item.preview" target="_blank" rel="noopener noreferrer">Посмотреть</a></td>
                          <td>
                            <v-btn flat color="grey darken-1" @click="templateCheck(props.item)">
                              Выбрать
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="checkCancel()">Закрыть</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->

              <div slot="widget-content">
                <v-dialog v-model="popupRemove.isOpen" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить обьект?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="popupRemove.isOpen = false">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="actionRemove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import colors from 'vuetify/es5/util/colors';
  import Util from '@/util';
  import Vue from 'vue';
  import VMdEditor from '@kangc/v-md-editor';
  import '@kangc/v-md-editor/lib/style/base-editor.css';
  import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
  import enUS from '@kangc/v-md-editor/lib/lang/en-US';

  VMdEditor.lang.use('en-US', enUS);

  VMdEditor.use(githubTheme);

  Vue.use(VMdEditor);

  export default {
    components: { },
    data () {
      return {
        modalData: {},
        oldModalData: {},
        editedIndex: {},
        dataToAdd: [],
        valid: true,
        readonlyFields: true,
        openColorBox: false,
        colors,
        rules: {
          required: [ v => !!v || 'Обязательное поле' ],
          /* emailTemplateKey: [
            v => !!v || 'Ключ не может быть пустым',
            v => v.split(' ').length === 1 || 'Нельзя использовать пробелы',
            v => this.emailTemplateData.filter(el => el.emailTemplateKey === v).length === 0 || 'Такой ключ уже существует',
          ], */
        },
        search: '',
        popupRemove: {
          isOpen: false
        },
        popupEdit: {
          isOpen: false,
          isEditing: false,
        },
        popupCheck: {
          isOpen: false,
          isEditing: false,
        },
        complex: {
          selected: [],
          headers: [
            {
              text: 'ID шаблона',
              value: 'id'
            },
            {
              text: 'Название шаблона',
              value: 'title'
            },
            /* {
              text: 'ID шаблона в SendPulse',
              value: 'sendPulseEmailTemplateId '
            }, */
            {
              text: 'Действует',
              value: 'isActive'
            },
            {
              text: 'Тема письма',
              value: 'emailSubject'
            },
            {
              text: "Действия",
              value: ""
            }
          ],
        },
        complexBySendPulse: {
          selected: [],
          headers: [
            {
              text: 'ID шаблона',
              value: 'id'
            },
            {
              text: 'Название шаблона',
              value: 'name'
            },
            {
              text: 'Дата создания',
              value: 'created'
            },
            {
              text: 'Просмотр',
              value: 'preview'
            },
            {
              text: "Действия",
              value: ""
            }
          ],
        }
      };
    },

    mounted: function() {

      /**
       * Загружаем данные по шаблонам при первой отрисовке страницы, если emailTemplateData не пустой, то не обновляемся
       */
      if (this.emailTemplateData.length === 0) {
          this.refresh();
      }

      /**
       * Загружаем данные по шаблонам при первой отрисовке страницы, если sendPulseEmailTemplateData не пустой, то не обновляемся
       */
      if (this.sendPulseEmailTemplateData.length === 0) {
          this.refresh();
      }
    },

    computed: {

      /**
       * Данные по шаблонам
       * @returns {default.computed.emailTemplateData|(function())|Array|getters.emailTemplateData}
       */
      emailTemplateData () { 
          return this.$store.getters['emailTemplate/emailTemplateData']
      },

      /**
       * Данные по шаблонам SendPulse
       * @returns {default.computed.sendPulseEmailTemplateData|(function())|Array|getters.sendPulseEmailTemplateData}
       */
      sendPulseEmailTemplateData () { 
          return this.$store.getters['emailTemplate/sendPulseEmailTemplateData']
      },
    },

    methods: {

      /**
       * Обновление данных по шаблонам
       */
      refresh() {
          this.$store._actions['emailTemplate/getEmailTemplateData'][0]();
          this.$store._actions['emailTemplate/getSendPulseEmailTemplateData'][0]();
      },

      /**
       * Открытие модального окна с редактированием, сохраняем старые данные и индекс элемента на случай отмены редактирования
       * @param item
       */
      editOpen(item) {
        // Если редактирование
        if (item !== null && typeof (item) !== 'undefined') { 
           this.modalData = item;
           this.oldModalData = Object.assign({}, this.modalData);
           this.editedIndex = this.emailTemplateData.indexOf(item);
           this.readonlyFields = true;
           // Если добавление
        } else {
          this.modalData = {
            id: -1,
            title: '',
            sendPulseEmailTemplateId: '',
            emailSubject: '',
            isActive: true,
          };
          this.oldModalData = {};
          this.editedIndex = -1;
          this.readonlyFields = false;
        }
        this.popupEdit.isOpen = true;
      },

      /**
       * Отмена редактирования
       */
      editCancel() {
        if (this.editedIndex != -1) {
          Object.assign(this.emailTemplateData[this.editedIndex], this.oldModalData);
        }
        this.popupEdit.isOpen = false;
      },

      /**
       * Сохранение отредактированного элемента
       */
      editSave() {
        if (this.$refs.form.validate()) {
          this.$store._actions['emailTemplate/saveEmailTemplateData'][0]({index: this.editedIndex, data: this.modalData}).then(() => {
            this.popupEdit.isOpen = false;
          })
        }
      },

      /**
       * Открытие модального окна для выбора шаблона письма SendPulse
       * 
       */
      checkOpen() {
        this.popupCheck.isOpen = true;
      },

      /**
       * Закрыть окно выбора шаблона письма SendPulse
       */
      checkCancel() {
        this.popupCheck.isOpen = false;
      },
      
      /**
       * Добавляем данные о шаблоне SendPulse в массив данных
       * @param item
       */
      templateCheck(item) {
        // toggle check
        // if (!this.dataToAdd.includes(item)) {
        //   this.dataToAdd.push(item);
        // } else {
        //   this.dataToAdd.splice(this.dataToAdd.indexOf(item), 1);
        // }
        if (this.modalData.title === '') {
          this.modalData.title = item.name;
        }
        this.modalData.sendPulseEmailTemplateId = item.real_id;
        this.popupCheck.isOpen = false;
      },

      /**
       * Открытие модального окна с подтверждением удаления
       * @param data
       */
      removeItemConfirm(data) {
        this.popupRemove.isOpen = true;
        this.modalData = data;
      },

      /**
       * Удаление элемента
       * @param item
       */
      actionRemove(item) {
        this.$store._actions['emailTemplate/removeEmailTemplateData'][0]({item: item});
        this.popupRemove.isOpen = false;
      }
    }
  };
</script>

<style>
  .v-chip__content{
    cursor: pointer!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/ui/EmailTemplate.vue